<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="4" sm="1" style="text-align: right">
            <label>科目编号：</label>
          </v-col>
          <v-col cols="4" sm="3">
            <v-text-field
              v-model="filter.subjectCode"
              @blur="getDataFromApi"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="1" style="text-align: right">
            <label>科目名称：</label>
          </v-col>
          <v-col cols="4" sm="3">
            <v-text-field
              v-model="filter.subjectName"
              @blur="getDataFromApi"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="3">
            <v-btn color="primary" depressed @click="getDataFromApi"
              >查询</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="courses"
        class="elevation-1"
        :loading="loading"
        :server-items-length="totalCourses"
        :page.sync="filter.pageNum"
        :items-per-page.sync="filter.pageSize"
        @update:page="handlePageChanged"
        @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:item.budgetStatus="{ item }">
          {{_jungleStatus(item.budgetStatus)}}
        </template>
        <template v-slot:item.planStatus="{ item }">
          {{_jungleStatus(item.planStatus)}}
        </template>
        <template v-slot:item.inspectionStatus="{ item }">
          {{_jungleStatus(item.inspectionStatus)}}
        </template>
        <template v-slot:item.operation="{ item }">
          <v-btn text color="primary" small  :disabled="!(_hasButtonPermission('编辑'))" @click="item.budgetStatus = 1- item.budgetStatus;doUpdate(item);getDataFromApi()"
            >{{item.budgetStatus == 0 ?'预算停用':'预算启用'}}</v-btn
          >
          <v-btn text color="primary" small  :disabled="!(_hasButtonPermission('编辑'))" @click="item.planStatus = 1 - item.planStatus;doUpdate(item);getDataFromApi()"
            >{{item.planStatus == 0?'计划停用':'计划启用'}}</v-btn
          >
          <v-btn text color="primary" small  :disabled="!(_hasButtonPermission('编辑'))" @click="item.inspectionStatus = 1- item.inspectionStatus;doUpdate(item);getDataFromApi()"
            >{{item.inspectionStatus==0?'巡检停用':'巡检启用'}}</v-btn
          >
        </template>
        <template v-slot:no-data> 查询出错或没有数据 </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
import {default as SubjectApi} from "@/api/pd/subject/SubjectApi.js";
export default {
  name: 'Pd-Manager-Subject',
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      filter: {
        subjectCode: "",
        subjectName: "",
        dateRange: [],
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        { text: "科目编号", value: "subjectCode", width: 100, sortable: false },
        { text: "科目名称", value: "subjectName", width: 100, sortable: false },
        { text: "预算状态", value: "budgetStatus", width: 100, sortable: false },
        { text: "计划状态", value: "planStatus", width: 100, sortable: false },
        { text: "巡检状态", value: "inspectionStatus", width: 100, sortable: false },
        { text: "最后修改人", value: "updateBy", width: 80, sortable: false },
        { text: "最后修改时间", value: "updateTimeString", width: 120, sortable: false },
        { text: "操作", value: "operation", width: 180, sortable: false },
      ],
      courses: [],
      loading: false,
      totalCourses: 0,
      valid: false
    };
  },
  mounted(){
	  this.getDataFromApi();
    this.getButtonPriviledge();
  },
  methods: {
      getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    handleSearch(){
		  this.getDataFromApi();	 
	  },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum
      this.getDataFromApi()
    },
    handlePageSizeChanged(pageSize) {
      if(pageSize==-1){
        pageSize = 100
      }
      this.filter.pageNum = 1
      this.filter.pageSize = pageSize
      this.getDataFromApi()
    },
    getDataFromApi() {
      this.loading = true;
      this.courses = [];
      let me = this;

      SubjectApi.get(this.filter).then(resp=>{
        SubjectApi.handleResponse(resp, me, function (data){
          me.loading = false;
          me.courses = data.rows;
          me.totalCourses = data.total;
        }, function (){
          me.loading = false;
        })
      }).catch(error=>{
        SubjectApi.handleNetworkError(error, me, function (){
          me.loading = false;
        })
      })
    },
    doUpdate(item){
      SubjectApi.update(item).then().catch(error=>{
        SubjectApi.handleNetworkError(error, me, function (){
          me.loading = false;
        })
      })
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    _jungleStatus(status){
      if(status == 1){
        return "启用"
      } else {
        return "禁用"
      }
    }
  },
};
</script>